import {useState} from "react";
import SectionPicker from "~/components/SectionPicker";
import PageHeading from "~/components/PageHeading";
import WaitlistList from "~/components/waitlist/WaitlistList";
import FlowBuilder from "~/components/flows/FlowBuilder";
import WaitlistSettings from "~/components/waitlist/WaitlistSettings";
import {getBusinessId} from "~/lib/Api";

const Waitlist = () => {
    const [section, setSection] = useState('list');

    return (
        <div>
            <PageHeading heading="Waitlisting" />
            <SectionPicker
                options={[
                    {value: 'list', label: 'Waitlist'},
                    {value: 'flows', label: 'Automations'},
                    {value: 'settings', label: 'Settings'}
                ]}
                value={section}
                onChange={setSection}
                className="mb-6"
            />

            {section === 'list' && <WaitlistList />}

            {section === 'flows' && <FlowBuilder flowableId={getBusinessId()} flowableType="waitlist" />}

            {section === 'settings' && <WaitlistSettings />}
        </div>
    )
}

export default Waitlist;

